import React, { useState, useEffect, useContext } from "react";
import { Row, Col, Button, Modal, Form } from "react-bootstrap";
import ModalInputText from "./ModalInputText";
import { Store } from "react-notifications-component";
import PermissionContext from "../../../Store/permission-context";

const EditInventoryModal = (props) => {
  const [ShowModal, setShowModal] = useState(props.show);
  const [Itemname, setItemname] = useState(props.Invrec.Itemname);
  const [SoldIn, setSoldIn] = useState(props.Invrec.SoldIn);
  const [Bulk, setBulk] = useState(props.Invrec.QuantityLeft);
  const [Unit, setUnit] = useState(props.Invrec.UnitLeft);
  const [CostPrice, setCostPrice] = useState(props.Invrec.CostPrice);
  const [Converter, setConverter] = useState(props.Invrec.Converter);
  const [BSP1, setBSP1] = useState(props.Invrec.BSP1);
  const [BSP2, setBSP2] = useState(props.Invrec.BSP2);
  const [BSP3, setBSP3] = useState(props.Invrec.BSP3);
  const [USP1, setUSP1] = useState(props.Invrec.USP1);
  const [USP2, setUSP2] = useState(props.Invrec.USP2);
  const [USP3, setUSP3] = useState(props.Invrec.USP3);
  const [ErrorSP1, setErrorSP1] = useState(false);
  const [ErrorSP2, setErrorSP2] = useState(false);
  const [ErrorSP3, setErrorSP3] = useState(false);
  const [ErrorUP1, setErrorUP1] = useState(false);
  const [ErrorUP2, setErrorUP2] = useState(false);
  const [ErrorUP3, setErrorUP3] = useState(false);
  const [checksp, setchecksp] = useState(false);
  const [checkup, setcheckup] = useState(false);
  const PCtx = useContext(PermissionContext);
  let errorbackground = {
    backgroundColor: "#f04e00",
    fontFamily: "Times New Roman",
  };
  let successbackground = {
    backgroundColor: "#00ca65",
    fontFamily: "Times New Roman",
  };
  const [errorBackStyle, seterrorBackStyle] = useState(errorbackground);
  const [successBackStyle, setsuccessBackStyle] = useState(successbackground);

  const cancelM = () => {
    setShowModal(false);
    props.cancelModal();
  };

  useEffect(() => {
    let cp = parseFloat(CostPrice);
    if (parseFloat(BSP1) >= 0 && BSP1 < cp) {
      setErrorSP1(true);
      PCtx.displayAlert(
        "Selling Price Error",
        "The " +
          SoldIn +
          " Selling Price 1 should not be less than " +
          SoldIn +
          "  Cost Price. Check the value(s) highlighted in Red",
        "danger"
      );
    } else {
      setErrorSP1(false);
    }

    if (parseFloat(BSP2) >= 0 && BSP2 < cp) {
      setErrorSP2(true);
      PCtx.displayAlert(
        "Selling Price Error",
        "The " +
          SoldIn +
          " Selling Price 2 should not be less than " +
          SoldIn +
          "  Cost Price. Check the value(s) highlighted in Red",
        "danger"
      );
    } else {
      setErrorSP2(false);
    }
    if (parseFloat(BSP3) >= 0 && parseFloat(BSP3) < cp) {
      setErrorSP3(true);
      PCtx.displayAlert(
        "Selling Price Error",
        "The " +
          SoldIn +
          " Selling Price 3 should not be less than " +
          SoldIn +
          "  Cost Price. Check the value(s) highlighted in Red",
        "danger"
      );
    } else {
      setErrorSP3(false);
    }
  }, [checksp]);

  useEffect(() => {
    let cp = Math.floor(parseFloat(CostPrice) / parseFloat(Converter));
    if (parseFloat(USP1) >= 0 && USP1 < cp) {
      setErrorUP1(true);
      PCtx.displayAlert(
        "Selling Price Error",
        "The Unit Selling Price 1 should not be less than Unit Cost Price. Check the value(s) highlighted in Red",
        "danger"
      );
    } else {
      setErrorUP1(false);
    }

    if (parseFloat(USP2) >= 0 && USP2 < cp) {
      setErrorUP2(true);
      PCtx.displayAlert(
        "Selling Price Error",
        "The Unit Selling Price 2 should not be less than Unit Cost Price. Check the value(s) highlighted in Red",
        "danger"
      );
    } else {
      setErrorUP2(false);
    }
    if (parseFloat(USP3) >= 0 && parseFloat(USP3) < cp) {
      setErrorUP3(true);
      PCtx.displayAlert(
        "Selling Price Error",
        "The Unit Selling Price 3 should not be less than Unit Cost Price. Check the value(s) highlighted in Red",
        "danger"
      );
    } else {
      setErrorUP3(false);
    }
  }, [checkup]);

  const CheckBulkPrice = () => {
    setchecksp(!checksp);
  };

  const CheckUnitPrice = () => {
    setcheckup(!checkup);
  };

  const saveTheRecord = (e) => {
    e.preventDefault();
    if (ErrorSP1 || ErrorSP2 || ErrorSP3 || ErrorUP1 || ErrorUP2 || ErrorUP3) {
      PCtx.displayAlert(
        "ERROR IN SAVING",
        Itemname +
          " properties cannot be saved. Please check the value(s) highlighted in Red.",
        "danger"
      );
    } else {
      let NewRecord = {
        GID: props.Invrec.GID,
        Itemname: props.Invrec.Itemname,
        SoldIn: props.Invrec.SoldIn,
        Bulk: Bulk,
        Unit: Unit,
        CostPrice: CostPrice,
        Converter: Converter,
        BSP1: BSP1,
        BSP2: BSP2,
        BSP3: BSP3,
        USP1: USP1,
        USP2: USP2,
        USP3: USP3,
      };

      props.SaveNewRecord(NewRecord);
    }
  };

  const thisChange = (e) => {
    let stt = e.target.name;
    let val = e.target.value;
    if (!isNaN(val)) {
      switch (stt) {
        case "Bulk":
          setBulk(val);
          break;
        case "Unit":
          setUnit(val);
          break;
        case "CostPrice":
          setCostPrice(val);
          break;
        case "Converter":
          setConverter(val);
          break;
        case "BSP1":
          setBSP1(val);
          break;
        case "BSP2":
          setBSP2(val);
          break;
        case "BSP3":
          setBSP3(val);
          break;
        case "USP1":
          setUSP1(val);
          break;
        case "USP2":
          setUSP2(val);
          break;
        case "USP3":
          setUSP3(val);
          break;
      }
    }
  };

  return (
    ShowModal && (
      <Modal
        show={ShowModal}
        onHide={cancelM}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header style={successBackStyle} closeButton>
          <Modal.Title>{props.Invrec.Itemname}</Modal.Title>
        </Modal.Header>
        <Modal.Body
          style={{
            fontFamily: "Times New Roman",
          }}
        >
          <Form onSubmit={saveTheRecord}>
            <Row className="justify-content-around">
              <Col md={6} sm={6} xs={6}>
                <ModalInputText
                  Label="Quantity Left"
                  Name="Bulk"
                  Val={Bulk}
                  thischange={thisChange}
                />
              </Col>
              <Col md={6} sm={6} xs={6}>
                <ModalInputText
                  Label="Unit Left"
                  Name="Unit"
                  Val={Unit}
                  thischange={thisChange}
                />
              </Col>
              <Col md={6} sm={6} xs={6}>
                <ModalInputText
                  Label="Cost Price"
                  Name="CostPrice"
                  Val={CostPrice}
                  thischange={thisChange}
                />
              </Col>
              <Col md={6} sm={6} xs={6}>
                <ModalInputText
                  Label={"A " + SoldIn + " contains"}
                  Name="Converter"
                  Val={Converter}
                  readonly={
                    SoldIn === "Unit" || SoldIn === "Piece" ? true : false
                  }
                  thischange={thisChange}
                />
              </Col>
              {SoldIn != "Unit" && SoldIn != "Piece" && (
                <Col md={4} sm={4} xs={4}>
                  <ModalInputText
                    Label={SoldIn + " S.Price 1"}
                    Name="BSP1"
                    Val={BSP1}
                    thischange={thisChange}
                    theAction={CheckBulkPrice}
                    error={ErrorSP1}
                  />
                </Col>
              )}
              {SoldIn != "Unit" && SoldIn != "Piece" && (
                <Col md={4} sm={4} xs={4}>
                  <ModalInputText
                    Label={SoldIn + " S.Price 2"}
                    Name="BSP2"
                    Val={BSP2}
                    thischange={thisChange}
                    theAction={CheckBulkPrice}
                    error={ErrorSP2}
                  />
                </Col>
              )}
              {SoldIn != "Unit" && SoldIn != "Piece" && (
                <Col md={4} sm={4} xs={4}>
                  <ModalInputText
                    Label={SoldIn + " S.Price 3"}
                    Name="BSP3"
                    Val={BSP3}
                    thischange={thisChange}
                    theAction={CheckBulkPrice}
                    error={ErrorSP3}
                  />
                </Col>
              )}

              <Col md={4} sm={4} xs={4}>
                <ModalInputText
                  Label="Unit S.Price 1"
                  Name="USP1"
                  Val={USP1}
                  thischange={thisChange}
                  theAction={CheckUnitPrice}
                  error={ErrorUP1}
                />
              </Col>

              <Col md={4} sm={4} xs={4}>
                <ModalInputText
                  Label="Unit S.Price 2"
                  Name="USP2"
                  Val={USP2}
                  thischange={thisChange}
                  theAction={CheckUnitPrice}
                  error={ErrorUP2}
                />
              </Col>
              <Col md={4} sm={4} xs={4}>
                <ModalInputText
                  Label="Unit S.Price 3"
                  Name="USP3"
                  Val={USP3}
                  thischange={thisChange}
                  theAction={CheckUnitPrice}
                  error={ErrorUP3}
                />
              </Col>
            </Row>
            <Row>
              <Col md={4} sm={4} xs={4}>
                <Button variant="outline-danger" onClick={cancelM}>
                  Cancel
                </Button>
              </Col>
              <Col md={4} sm={4} xs={4}>
                <Button variant="outline-success" type="submit">
                  Save
                </Button>
              </Col>
            </Row>
          </Form>
        </Modal.Body>
      </Modal>
    )
  );
};

export default EditInventoryModal;
